import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Back15 = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 20.26 23.12'
  >
    <g>
      <path
        d='M12,3l1.71-1.22A1,1,0,1,0,12.53.19L8.2,3.27l3.08,4.34A1,1,0,0,0,12.1,8a1,1,0,0,0,.58-.19,1,1,0,0,0,.23-1.39l-1-1.39A8.13,8.13,0,1,1,2,13a1,1,0,0,0-2,0A10.13,10.13,0,1,0,12,3Z'
        fill={ color }
      />
      <polygon
        fill={ color }
        points='7.06 16.46 8.13 16.46 8.13 10.5 7.14 10.5 5.62 11.42 5.62 12.54 7.06 11.67 7.06 16.46'
      />
      <path
        d='M11.63,15.61a1.46,1.46,0,0,1-.92-.26,1.31,1.31,0,0,1-.47-.76l-1,.32a2.09,2.09,0,0,0,.84,1.25,2.76,2.76,0,0,0,1.57.44,2.67,2.67,0,0,0,1.22-.27A2,2,0,0,0,14,14.49a2,2,0,0,0-.28-1.05,1.82,1.82,0,0,0-.78-.72,2.33,2.33,0,0,0-1.13-.27,2.27,2.27,0,0,0-1.27.36h0l.25-1.32h2.64v-1H9.94l-.59,3.11,1,.25a1.83,1.83,0,0,1,1.3-.53,1.32,1.32,0,0,1,.92.32,1.13,1.13,0,0,1,0,1.65A1.31,1.31,0,0,1,11.63,15.61Z'
        fill={ color }
      />
    </g>
  </svg>
);

Back15.propTypes = { ...iconPropTypes };

Back15.defaultProps = { ...iconDefaultProps };

export default Back15;